import { ClbHeaderBrand } from "@celebration/react";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";

const HeaderBrand = () => {
  const navigate = useSafeNavigate();

  const goToHome = () => {
    void navigate("/");
  };

  return (
    <ClbHeaderBrand onClick={goToHome}>
      <img
        alt="logomarca"
        src="./assets/sentinel/logo-horizontal-color.png"
        style={{ cursor: "pointer" }}
      />
    </ClbHeaderBrand>
  );
};

export default HeaderBrand;
